import React from 'react';
import PropTypes from 'prop-types';
import BaseDialog from './BaseDialog';

const ImprintDialog = ({ open, onClose }) => {
  const text =
    `<h1>Impressum</h1>
    <p><strong>cala media GbR</strong></p>
    <p>Neutorstr. 11<br>55116 Mainz</p>
    <p>T: 0 61 31 - 600 74 04<br>
    F: 0 61 31 - 617 66 36<br>
    E: <a href="mailto:info@calamedia.de">info@calamedia.de</a></p>
    <p><a href="http://www.calamedia.de">www.calamedia.de</a></p>
    <p><strong>Gesellschafter</strong></p>
    <p>Alexandra Beckmann<br>
    Lutz Bellingrath, Christine Stockmeyer</p>
    <p><strong>BERUFSHAFTPFLICHT</strong></p>
    <p>cala media GbR hat die folgenden Berufshaftpflichtversicherungen abgeschlossen:</p>
    <p>Vermögensschaden-Haftpflichtversicherung<br>Betriebshaftpflichtversicherung<br>Umwelthaftpflicht-Basisversicherung<br>Umwelthaftpflicht-Regressversicherung<br>Die Versicherungen bestehen bei der R+V Versicherung AG, Taunusstraße 1, 65193 Wiesbaden.</p><p>Räumlicher Geltungsbereich: Im gesamten EU-Gebiet und den Staaten des Abkommens über den Europäischen Wirtschaftsraum.</p>
    <p>Alle Informationen auf atomuhr-zeit.de sind ohne Gewähr. Trotz aufwändiger und gewissenhafter Recherche der unter https://www.atomuhr-zeit.de angebotenen Informationen wird keine Haftung für die Richtigkeit der Angaben übernommen.</p><p>Bildmaterial: cala media GbR</p>    
  `;

  return (
    <BaseDialog open={open} title="Impressum" text={{ __html: text }} onClose={onClose} />
  );
};


ImprintDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

ImprintDialog.defaultProps = {
  open: false,
};

export default ImprintDialog;



// WEBPACK FOOTER //
// ./src/components/layout/ImprintDialog.js